// eslint-disable-next-line import/prefer-default-export
export const PHONE_VERIFICATION_CODE_LENGTH = 6;
